import React, { useState, useCallback } from 'react';
import { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import Form from "react-bootstrap/Form";
import { useForm } from "react-hook-form";
import Button from "react-bootstrap/Button";
import UserService from "../services/user.service";

const ContactUs = () => {
    const [token, setToken] = useState();
    const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);
    const [message, setMessage] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const { executeRecaptcha } = useGoogleReCaptcha();

    const { register, handleSubmit, watch, formState: { errors } } = useForm({
        defaultValues: {},
    });

    const onSubmit = async (data) => {
        if (!executeRecaptcha) {
            console.log('Execute recaptcha not yet available');
            setMessage("reCAPTCHA not loaded. Please refresh the page and try again.");
            return;
        }

        try {
            const token = await executeRecaptcha('contactus');
            console.log("RECAPTCHA TOKEN", token);

            setSubmitting(true);
            setMessage("");

            // Send token along with form data to backend
            const dataWithToken = {
                ...data,
                recaptchaToken: token
            };

            var status = await UserService.submitContactUs(dataWithToken);
            if (status) {
                setSubmitted(true);
            }
        } catch (error) {
            console.error("Error submitting contact form:", error);
            setMessage(error.response?.data?.message || "Failed to submit contact form. Please try again.");
            setSubmitting(false);
        }
    }

    const onChange = (value) => {
        console.log("Captcha value:", value);
        setToken(value);
        setMessage("");
    }


    return (
        <>
            {submitted && (

                <Container>
                    <Row>
                        <Col>
                            <h2>Thank you for contacting us!</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <p>We have received your message and will get back to you as soon as possible.</p>
                            <p><a href="/home">Return to Shopping</a></p>
                        </Col>
                    </Row>
                </Container>
            )}
            {!submitted && (
                <Container>
                    <Row>
                        <Col>
                            <h2>Contact Us</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <p>Have a question or comment? Send us a message!</p>
                            <p>Fill out the form below and we'll get back to you as soon as possible.</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <Form.Group className="mb-3" controlId="name">
                                    <Form.Label>Name</Form.Label>
                                    <input {...register("name", { required: true })} /><br />
                                    {errors.name && <div className="error" >Name is required</div>}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="email">
                                    <Form.Label>Email Address</Form.Label>
                                    <input {...register("email", { required: true })} /><br />
                                    {errors.email && <div className="error" >Email Address is required</div>}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="state">
                                    <Form.Label>Reason</Form.Label>
                                    <select
                                        name="reason"
                                        {...register("reason", { required: true })}
                                    >
                                        <option value="">Select a Reason</option>
                                        <option value="Login Issues">Login Issues</option>
                                        <option value="Registration Issues">Registration Issues</option>
                                        <option value="Order Issues">Order Issues</option>
                                        <option value="General Inquiry">General Inquiry</option>
                                    </select>
                                    {errors.reason?.type === 'required' && <div className="error" >Reason is required</div>}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="orderNum">
                                    <Form.Label>Order Numbers (if applicable)</Form.Label>
                                    <input {...register("orderNum", {})} /><br />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="message">
                                    <Form.Label>Message</Form.Label>
                                    <textarea {...register("message", { required: true })} /><br />
                                    {errors.message?.type === 'required' && <div className="error" >Message is required</div>}
                                </Form.Group>

                                {message && message != "" && (<div className="error" >{message}</div>)}
                                <p style={{ marginTop: 20 }}>
                                    <Button variant="primary" onClick={handleSubmit(onSubmit)} disabled={submitting} type="submit">
                                        Submit Contact
                                    </Button>
                                </p>

                            </Form>
                        </Col>
                    </Row>
                </Container>
            )}
        </>
    );
};

export default ContactUs;